import React from 'react'
import { Product } from '../../../modules/productsListing/types'
import { Typography } from '@mui/material'
import { useStyles } from './ProductNameSection.styles'

export type ProductNameSectionProps = {
  product: Product
}

export const ProductNameSection: React.FC<ProductNameSectionProps> = ({
  product,
}) => {
  const { classes } = useStyles()
  return (
    <div
      className={classes.productNameWrapper}
      data-testid="product-name-section"
    >
      <div className={classes.textContainer}>
        <Typography className={classes.sectionText}>Product</Typography>
        <Typography
          className={classes.sectionHeading}
          data-testid="product-name"
        >
          {product.productName}
        </Typography>
      </div>
    </div>
  )
}
